import React, { useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import MainService from "../../common/MainService";
import { useCallback } from "react";

// Define the container style for the map (full screen width and height)
const containerStyle = {
  width: "100vw",  // Full viewport width
  height: "100vh", // Full viewport height
};

// Define the default center of the map (latitude and longitude)
const center = {
  lat: 28.6448,   // Latitude for the center
  lng: 77.216721, // Longitude for the center
};

function FarmLocation() {
  // State for holding the list of users (initially empty)
  const [users, setUsers] = useState([]);

  // State for holding the location markers on the map
  const [locationMarker, setLocationMarker] = useState([]);

  // Function to fetch all users of the "FOOD-PROCESSOR" user type (AAMC)
  const getAlluserType = () => {
    MainService.getAllUserofUserType("AAMC").then((res) => {
      // Extract the usernames from the response and set them to state
      const allusers = res.users.map((e) => e.username);
      setUsers(allusers);
    });
  };

  // Callback function to fetch the store locations for all users
  const getStoreLocation = useCallback(() => {
    // Check if 'users' array is valid, else return an empty array
    if (!Array.isArray(users) || users.length === 0) {
      return []; // No users, return empty array
    }

    // Map over users to fetch their store locations using the MainService
    const allLocationPromises = users.map((username) => 
      MainService.locationProvider(username, "Farm").then((res) => res)
    );

    // Return all promises to fetch locations
    return allLocationPromises;
  }, [users]); // Dependency on 'users' to re-fetch locations when users change

  useEffect(() => {
    // Fetch users when the component mounts (only once)
    getAlluserType();
  }, []); // Empty dependency array to run this effect once when the component mounts

  useEffect(() => {
    // Fetch locations when users are available
    if (users.length > 0) {
      // Wait for all location promises to resolve
      Promise.all(getStoreLocation())
        .then((res) => {
          // Flatten the location data and set markers for each location
          const locations = res.flatMap((locationData) => locationData.sites);
          setLocationMarker(locations);
        })
        .catch((err) => {
          // Log any errors during the location fetching process
          console.error("Error occurred:", err);
        });
    }
  }, [users, getStoreLocation]); // Dependency on 'users' to trigger fetching locations when users change

  // Load Google Maps API script using the provided key
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA08TJWvLGvDD4cXLo-231gioXgaugKUw0", // Google Maps API key
  });

  return isLoaded ? (
    // Render the Google Map if it is loaded
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
      {/* Render markers for each location */}
      {locationMarker
        .flat() // Flatten the array of arrays into one array of marker objects
        .map((marker, index) => (
          <Marker
            key={index}  // Unique key for each marker based on the index
            name={marker.sitename}  // The name of the site (marker)
            position={{
              lat: parseFloat(marker.latitude), // Convert latitude to float for map positioning
              lng: parseFloat(marker.longitude), // Convert longitude to float for map positioning
            }}
            title={marker.sitename} // Tooltip title for the marker
          />
        ))}
    </GoogleMap>
  ) : (
    // Return an empty fragment if the map isn't loaded yet
    <></>
  );
}

// Memoize the FarmLocation component to avoid unnecessary re-renders
export default React.memo(FarmLocation);
